/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DelegateProfilePage_manager = {
    readonly " $fragmentRefs": FragmentRefs<"BackgroundCheckCard_manager">;
    readonly " $refType": "DelegateProfilePage_manager";
};
export type DelegateProfilePage_manager$data = DelegateProfilePage_manager;
export type DelegateProfilePage_manager$key = {
    readonly " $data"?: DelegateProfilePage_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DelegateProfilePage_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BackgroundCheckCard_manager",
            "args": null
        }
    ]
} as any);
(node as any).hash = '1a105079ffdd0e3af3d9f97a22f2867d';
export default node;
